import {IconButton, Tooltip} from "@material-ui/core"
import RefreshIcon from "@material-ui/icons/Refresh"
import ZoomInIcon from "@material-ui/icons/ZoomIn"
import ZoomOutIcon from "@material-ui/icons/ZoomOut"
import React, {useState} from "react"
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch"
import imagePlaceholder from "../../../../../assets/imagePlaceholder.svg"

const ReportImagePreviewItem = ({url, title = "Image"}) => {
  const [imgSrc, setImgSrc] = useState(url)

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        backgroundColor: "#f0f0f0",
        borderRadius: 8,
      }}
    >
      <TransformWrapper
        initialScale={1}
        minScale={0.5}
        maxScale={4}
        wheel={{disabled: false}}
        doubleClick={{disabled: false}}
        pinch={{disabled: false}}
        panning={{disabled: false}}
      >
        {({zoomIn, zoomOut, resetTransform}) => (
          <>
            {/* Optional Controls */}
            <div
              style={{
                display: "flex",
                gap: 8,
                padding: 8,
                justifyContent: "center",
              }}
            >
              <Tooltip title="Zoom Out">
                <IconButton color="primary" onClick={() => zoomOut()}>
                  <ZoomOutIcon/>
                </IconButton>
              </Tooltip>

              <Tooltip title="Zoom In">
                <IconButton color="primary" onClick={() => zoomIn()}>
                  <ZoomInIcon/>
                </IconButton>
              </Tooltip>

              <Tooltip title="Reset">
                <IconButton color="secondary" onClick={() => resetTransform()}>
                  <RefreshIcon/>
                </IconButton>
              </Tooltip>
            </div>

            <TransformComponent
              wrapperStyle={{width: "100%", height: "100%"}}
            >
              <img
                src={imgSrc}
                alt={title}
                onError={() => setImgSrc(imagePlaceholder)}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  objectPosition: "center",
                }}
              />
            </TransformComponent>
          </>
        )}
      </TransformWrapper>
    </div>
  )
}

export default ReportImagePreviewItem
